<template>
  <div class='h-topogjxx-sidebj'>
		
		<div class='h-toolbarBg h-topo-margin'>
            <div :class='[hasBorder ? "h-borderBox-top" : "h-inputBox"]' >
                <div :class='{"col-xs-12 col-sm-12 col-lg-12 col-md-12": hasBorder}' >
                    <ejs-textbox :placeholder='$t("System.inputTip7")' @keydown.enter.native="search" v-model='input' />
                </div>
            </div>
        </div>
        
	    <ejs-grid :dataSource='fmData' ref='grid' :class=' { "h-borderBox-content": hasBorder }'>
	      <e-columns>
		      <!-- TODO field 需要变 -->
		        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' width='6%' clipMode='EllipsisWithTooltip'></e-column>
		        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip'></e-column>
		        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
		        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
		        <e-column field='neName' :visible='false' :headerText='$t("Alarm.neName")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
		        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' width='11%' clipMode='EllipsisWithTooltip'></e-column>
		        <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter='clearFormat'></e-column>
		   </e-columns>
	    </ejs-grid>
  </div>
</template>

<script>
let dataSource = [];
export default {
	name: 'EquipmentAlarmShowDialog',
	props: ['hasBorder'],
	data() {
		return {
			input:'',
			page: {
				pageNo: 1,
				pageSize: 10,
				totalCount: 0
			},
			queryConditions: {
				systemId: '1',
				conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
				keywords: '', // 模糊查询关键字
			},
			fmData: [],
			roleNetList : [],
			roleNe:[],
			conditions: {
				alarmTime: {
				  createTime: '',
				  clearTime: '',
				  confirmTime: ''
				},
				alarmLevel: [],
				alarmType: [],
				nodeIds: [],
				ne: [],
				alarmState:{
				  clearState: 0,
				  confirmState: ''
				},
                UserId: '',
			},
		}
	},
	methods: {
        clearFormat(grid, data) {
	      return this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
	    },
        levelFormat(grids, data) {
	      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
	    },
      	async beforeMount(id) {
		    const This = this;
		    this.$loading.showLoadding(this.$t('Software.Searching'));
		    
		     // 权限控制如果是Eadmin账户有任何权限
	        let username = '';
	        let principal = sessionStorage.getItem('principal');
	        if (!!principal) {
	          let user = JSON.parse(principal);
	          username = user.username;
	        }
	        
	        var netNodes = [id];   
	        await this.getAuth2(username, netNodes).then(result => {
			            
			    	if (result.success == false || result.authNetId == null || result.authNetId.length == 0) {
			    		EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.permissionDenied') });
			    		return;
			    	}			       
				
										 
					for (let i = 0; i < result.authNetId.length; i++) {
			          This.roleNetList.push(result.authNetId[i].toString());
			        }
					
					//This.roleNetList = result.authNetId;
									
					This.getAlarmListData(id);					                   
		    });	
  		},
  		async getAuth2(username, netNodes) {
			//-- 获取网元权限
			//-- this is retrun result 
			var resultModel = function(){
				this.success = false;
				this.admin = false;
				this.authNetId = [];
			}; 
			var result = new resultModel();	      
			if( netNodes == null || netNodes.length == 0 )
				return result;

			let IsAdminRole = false;
			await this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {
				if (response && response.status === 200 && response.data !== undefined)
					IsAdminRole = response.data;

			});
			//-- admin has all Net
			if (username === 'Eadmin' || IsAdminRole == true || username == 'unmadmin') 
			{
				result.success = true;
				result.admin = true;      		
				result.authNetId = netNodes;
					
				return result;
			}     
	     	 
			let authList = [];
			await this.$axios.get('/lte/ems/auth/findAuthNodeList').then(response => {
				if (response && response.status === 200 && response.data && response.data.length > 0) {
				  response.data.forEach(element => {
						authList.push(element.nodeId.toString());
				  });
				}
			});	      
	     
			let abc = netNodes;      
			for(var j = 0; j < netNodes.length; j++)
			{
				if( netNodes[j].type == '0')
				{	//-- subnet has auth
					result.success = true;
					result.authNetId.push( netNodes[j].id );
					continue;
				}
				
				const hasPermis = authList.find(v => v === netNodes[j].id);	      
				if(hasPermis == undefined || hasPermis == null)
					continue;	      		
				
				result.success = true;
				result.authNetId.push( netNodes[j].id );
			}
				
			return result;
		},
    	getAlarmListData(id) {
    	
				const neIds=[10];
				const This = this;
				//const l = This.roleNetList;
				if (id instanceof Array) {
					this.conditions.nodeIds = id;
				} 
				else {
					this.conditions.nodeIds = [id];
				}
				const principal = sessionStorage.getItem('principal');
      			const user = JSON.parse(principal);
      			this.conditions.UserId = user.userId;
				This.$axios.post('/lte/ems/fm/alarmcurrent/queryAlarm.html', {
					conditions: JSON.stringify(this.conditions),
					keywords: "",
					roleNe: This.roleNetList
				}).then((response) => {
					if (response && response.status === 200) {
					  this.$loading.hideLoadding();
					  this.dataSource = response.data.resultVal;
					  this.fmData = this.dataSource;
					}
				});
    	},
        search(args) {
				if(this.input === '') {
					this.fmData = this.dataSource;
				}
				else {

					var filterdata = this.dataSource.filter( item => {
						let columntext = Array.from(this.$refs.grid.getColumns(), x => {
						  return x.field;
						});

						let feildData = Array.from(columntext, x => {
						  return item[x] === null ? '' : item[x] +'';
						});
						let filres = false;
						feildData.forEach(item => {
						  if(item.indexOf(this.input) > -1)
						  {
							filres = true;
						  }
						});
						return filres;
					}).map( item => { return item });
					this.fmData = filterdata;

				}
		}
	},
	mounted() {
	},
}
</script>
